import _ from 'lodash';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import React from 'react';

import { Button, DialogActions, DialogContent } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import { withStyles } from '@material-ui/core/styles';

import Transition from '../../../../components/dialogs/Transition';
import FormDatePicker from '../../../../components/form/FormDatePicker';
import FormComponent from '../../../../components/FormComponent';
import { post } from '../../../../modules/utility';

// import FormTimePicker from '../../../../components/form/FormTimePicker';
import { ENTER_TIME_EVENT_TYPE, generalStyles, getOverrideParams } from '../util';
import { dialogStyles } from './dialogStyles';
import MobileDeliveryDialogSavePopup from './MobileDeliveryDialogSavePopup';
import FormText from '../../../../components/form/FormText';

const viewportWidth = window.innerWidth;
const datePickerScaleSize = _.round(viewportWidth / 450, 2); // change the reference width as necessary
const datePickerScaleWidth = _.round((70 * 450) / viewportWidth, 2);

const styles = () => {
	return {
		...generalStyles,
		...dialogStyles,
	};
};

class MobileDeliveryEnterTimeDialog extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			dateOfEvent: moment().format('YYYY-MM-DD'),
			timeOfEventHour: moment().format('HH'),
			timeOfEventMinute: moment().format('mm'),
		};
	}
	componentDidMount() {}

	componentDidUpdate(prevProps, _prevState, _snapShot) {
		if (!prevProps.open && this.props.open) {
			if (this.props.eventDateTime) {
				const momentOfEvent = moment(this.props.eventDateTime);

				this.setState({
					isSaving: false,
					hasSavingSuccess: false,
					hasSavingError: false,
					savingError: '',
					dateOfEvent: moment(this.props.eventDateTime).format('YYYY-MM-DD'),
					timeOfEventHour: momentOfEvent.format('HH'),
					timeOfEventMinute: momentOfEvent.format('mm'),
				});
			} else {
				this.setState({
					dateOfEvent: moment().format('YYYY-MM-DD'),
					timeOfEventHour: moment().format('HH'),
					timeOfEventMinute: moment().format('mm'),
				});
			}
		}
	}

	handleSubmit = () => {
		const { stopNumber, tmwOrderId, moveNumber } = this.props;
		const { dateOfEvent, timeOfEventHour, timeOfEventMinute } = this.state;

		const formFieldError = {};
		const errors = [];

		if (!dateOfEvent) {
			formFieldError.products = 'Date is required';
			errors.push('Date is required');
		}

		if (_.isNil(timeOfEventHour) || _.isNil(timeOfEventMinute)) {
			formFieldError.products = 'Time hour / minute is required';
			errors.push('Time is required');
		}
		const parsedHour = parseInt(timeOfEventHour);
		const parsedMinute = parseInt(timeOfEventMinute);

		if (_.isNaN(parsedHour) || _.isNaN(parsedMinute)) {
			formFieldError.products = 'Time hour / minute must be only digits';
			errors.push('Time hour / minute must be only digits');
		}

		if (_.keys(formFieldError).length) {
			this.setState({
				formFieldError,
				isSaving: false,
				hasSavingSuccess: false,
				hasSavingError: true,
				savingError: errors.join('\n'),
			});
			return;
		}

		const dateMoment = moment(dateOfEvent);
		dateMoment.hour(parsedHour);
		dateMoment.minute(parsedMinute);
		const dateTimeOfEvent = dateMoment.utc().format('YYYY-MM-DD HH:mm:ss');
		this.submitApi({ tmwOrderId, moveNumber, stopNumber, dateTimeOfEvent });
	};

	submitApi = ({ tmwOrderId, moveNumber, stopNumber, dateTimeOfEvent }) => {
		const { eventType } = this.props;
		const setFetching = this.props.setFetching;
		setFetching({ isFetching: true });
		this.setState({ isSaving: true, formFieldError: {}, hasSavingSuccess: false });

		const params = {
			...getOverrideParams(),
			tmwOrderId,
			moveNumber,
			stopNumber,
			dateOfEvent: dateTimeOfEvent,
		};

		const method =
			eventType === ENTER_TIME_EVENT_TYPE.ARRIVAL
				? 'tmw.deliveryTicket.arriveAtStop'
				: 'tmw.deliveryTicket.departStop';

		// We used to have leave yard here

		post({
			method,
			params,
			callback: (err) => {
				if (err) {
					this.setState({
						isSaving: false,
						hasSavingSuccess: false,
					});

					return setFetching({
						isFetching: false,
						isShowErrorDialogOpen: true,
						errorDialogMessages: err,
					});
				}

				this.props.getDeliveryTickets({
					callback: () => {
						this.setState({
							isSaving: false,
							hasSavingSuccess: true,
						});
					},
				});
			},
		});
	};

	handleClose = () => {
		this.setState({
			savingSuccessful: false,
			isSaving: false,
		});
		this.props.onClose();
	};

	render() {
		const { open, classes, eventType } = this.props;
		const { isSaving, hasSavingSuccess, hasSavingError, savingError } = this.state;

		const scaleStyle = {
			transform: `scale(${datePickerScaleSize})`,
			position: 'relative',
			width: `${datePickerScaleWidth}%`,
			paddingBottom: '2vw',
			transformOrigin: 'left',
		};

		const word =
			eventType === ENTER_TIME_EVENT_TYPE.ARRIVAL
				? 'Arrival'
				: eventType === ENTER_TIME_EVENT_TYPE.DEPARTURE
				? 'Departure'
				: 'Leaving Yard';

		return (
			<Dialog
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				fullWidth={true}
				//fullScreen={true}
				maxWidth={'lg'}
				classes={{ scrollPaper: classes.dialogRoot, paper: classes.dialogPaper }}
			>
				<DialogContent dividers={true} style={{ position: 'relative' }}>
					<div className={classes.dialogTitle} style={{ marginBottom: '4vw' }}>
						<div>Enter Date / Time {word}</div>
					</div>
					<div style={scaleStyle}>
						<FormDatePicker
							{...this.setForm('dateOfEvent', `${word} Date`, true)}
							isYearPicker={false}
							gridProps={{ md: 12 }}
							shouldScaleForMobile={true}
						/>
					</div>

					<div style={{ marginBottom: '2vw' }}>
						<div
							style={{
								marginTop: '1vw',
								fontSize: '120%',
								color: '#777',
								marginBottom: '2vw',
							}}
						>
							{word} Time
						</div>
						<div style={{ display: 'flex' }}>
							<FormText {...this.setForm(`timeOfEventHour`, 'Hour')} variant="outlined" />
							<div style={{ margin: '2vw', marginTop: '3vw', fontWeight: 900, fontSize: '200%' }}>
								:
							</div>
							<FormText {...this.setForm(`timeOfEventMinute`, 'Minute')} variant="outlined" />
						</div>
						<div
							style={{
								marginTop: '1vw',
								fontSize: '120%',
								color: '#777',
								marginBottom: '2vw',
							}}
						>
							Military time (hour: 0-23)
						</div>
					</div>
				</DialogContent>

				<DialogActions
					style={{ position: 'relative', backgroundColor: '#f7f7f7', padding: '2vw 0vw' }}
				>
					<MobileDeliveryDialogSavePopup
						classes={classes}
						isSaving={isSaving}
						hasSavingSuccess={hasSavingSuccess}
						hasSavingError={hasSavingError}
						savingError={savingError}
						savingSuccess={'Date / time saved and order refreshed.'}
					/>

					<div style={{ display: 'flex', width: '100%', padding: '0 2vw' }}>
						<Button
							variant="contained"
							color="primary"
							aria-label="submitRackDelay"
							className={classes.dialogSubmitButton}
							onClick={this.handleSubmit}
							disabled={isSaving}
						>
							Save
						</Button>

						<Button
							variant="outlined"
							className={classes.dialogCloseButton}
							onClick={this.handleClose}
							disabled={isSaving}
						>
							Close
						</Button>
					</div>
				</DialogActions>
			</Dialog>
		);
	}
}

MobileDeliveryEnterTimeDialog.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func,
	classes: PropTypes.object,

	stopNumber: PropTypes.number,
	tmwOrderId: PropTypes.number,
	moveNumber: PropTypes.number,

	// req
	setFetching: PropTypes.func.isRequired,
	getDeliveryTickets: PropTypes.func.isRequired,
	eventType: PropTypes.string,
	eventDateTime: PropTypes.string,
};

export default _.flow([withStyles(styles)])(MobileDeliveryEnterTimeDialog);
